import {Box} from '@primer/react'
import type React from 'react'

type StaticFileFrameProps = {
  header: React.ReactNode
}

export const StaticFileFrame = (props: React.PropsWithChildren<StaticFileFrameProps>) => {
  const {header} = props
  return (
    <Box sx={{minWidth: 0}}>
      <Box
        sx={{
          bg: 'canvas.subtle',
          pl: 2,
          pr: 3,
          py: 2,
          borderRadius: 'initial',
          borderTopLeftRadius: 2,
          borderTopRightRadius: 2,
          borderColor: 'border.default',
          borderWidth: 1,
          borderStyle: 'solid',
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          height: '40px',
        }}
      >
        {header}
      </Box>
      <Box
        sx={{
          borderColor: 'border.default',
          borderBottomWidth: 1,
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
          borderTopWidth: 0,
          borderLeftWidth: 1,
          borderRightWidth: 1,
          borderStyle: 'solid',
          overflow: 'hidden',
        }}
      >
        {props.children}
      </Box>
    </Box>
  )
}

try{ StaticFileFrame.displayName ||= 'StaticFileFrame' } catch {}